import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Paper, Icon } from '@material-ui/core';
import './SendShoutout.scss';
import { UsersSelector, PrismButton } from './';
import { createShoutout } from '../actions/ShoutoutsActions';
import { setTextFieldFocus, setShowSendShoutoutModal } from '../actions/HotkeyActions';
import { TagSelector } from './TagSelector';
import PhotoSelector from './PhotoSelector';

class SendShoutout extends Component {
  state = {
    selectedUserID: null,
    selectedTeam: null,
    message: '',
    isEditing: false,
    isSending: false,
    selectedUsers: [],
    selectedTags: [],
    characterCount: 0,
    dragCounter: 0,
    dragText: "drag",
    dropComplete: false,
    photoElement: null,
    photoLoading: false,
    imageError: ''
  };

  dragOverlayRef = null
  selector = null;
  sendShoutoutTextarea = null;
  dropdownComponent = null;
  maxWidth = 430;
  maxHeight = 226;
  originalScreenHeight = window.innerHeight;


  UNSAFE_componentWillMount() {
    if (this.props.startWithUser) {
      this.setState({ isEditing: true, selectedUsers: [ this.props.startWithUser ] });
    }
    if (this.props.startBig) {
      this.setState({ isEditing: true });
    }
  }

  componentDidMount() {
    window.addEventListener("dragenter", this.handleDragover.bind(this));
    window.addEventListener("dragleave", this.handleDragleave.bind(this));
    window.addEventListener("drop", this.handleDrop.bind(this));
    if (window.innerWidth < 480) window.addEventListener("resize", this.handleKeyboard.bind(this));

    if (this.dragOverlayRef) this.dragOverlayRef.addEventListener("dragenter", () => this.setBoxText("Drop"));
    if (this.dragOverlayRef) this.dragOverlayRef.addEventListener("dragleave", () => this.setBoxText("Drag"));


    if (this.props.startWithUser) {
      this.sendShoutoutTextarea.focus();
    } else if (this.props.modalMode && window.innerWidth > 480) {
      this.dropdownComponent.userDropdown.openDropdown();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("dragenter", this.handleDragOver);
    window.removeEventListener("dragleave", this.handleDragleave);
    window.removeEventListener("resize", this.handleKeyboard);
    this.dragOverlayRef.removeEventListener("dragenter", this.setBoxText);
    this.dragOverlayRef.removeEventListener("dragleave", this.setBoxText);
    window.removeEventListener("drop", this.handleDrop());
  }

  setBoxText(text) {
    this.setState({ dragText: text });
  }

  handleDragover() {
    this.setState({ dropComplete: false, dragCounter: this.state.dragCounter + 1 });
    if (!this.state.isEditing && window.innerWidth > 480) this.setState({ isEditing: true });
    else if (window.innerWidth < 480 && !this.state.isEditing) {
      this.props.setShowSendShoutoutModal(true);
    }
  }

  handleDragleave() {
    this.setState({ dropComplete: false, dragCounter: this.state.dragCounter - 1 });
  }

  handleDrop() {
    this.setState({ dropComplete: true });
  }

  handleKeyboard() {
    let backdrop = document.getElementsByClassName('modalBackdrop')[0];
    backdrop.style.height = this.originalScreenHeight + 'px';
  }

  // selectTeam(id) {
  //   this.userDropdown.clearDropdown();
  //   this.setState({ selectedTeam: id, selectedUserID: '' });
  // }

  get isShoutoutValid() {
    const { selectedUsers, message } = this.state;

    return message.length > 0 && message.length <= 250 && selectedUsers.length > 0;
  }

  getTeamIdFromName(name) {
    return this.props.teams.filter((team) => team.name === name)[0];
  }

  async sendShoutout() {
    if (!this.state.isSending) {
      const { message } = this.state;

      this.setState({ isSending: true });

      try {
        await this.props.createShoutout(this.state.selectedUsers.map(user => user.uid), message,
          this.state.selectedTags.map(tag => tag._id), this.selector.state.fileId);
        if (this.selector) this.selector.removePhoto();
        this.setState({ selectedUsers: [], selectedTags: [], showTags: false, message: '', characterCount: 0  });
        setTimeout(() => {
          this.setState({ isSending: false, isEditing: false });
        }, 800);

        this.dropdownComponent.userDropdown.dropdownInput.current.focus();

        if (this.props.onClose) {
          this.props.onClose();
          this.props.setTextFieldFocus(false);
          this.props.setShowSendShoutoutModal(false);
        } else this.backgroundClick();
      } catch (error) {
        //this.props.doneCreating();
        this.setState({ isSending: false });
        console.error(error);
      }
    }
  }

  shoutoutMessageChanged(event) {
    const text = event.target.value || '';

    this.setState({ ...this.state,
      message: text,
      characterCount: text.length
    });
  }

  backgroundClick() {
    this.props.setShowSendShoutoutModal(false);
    this.setState({ isEditing: false, selectedUsers: [], selectedTags: [], showTags: false, message: '', characterCount: 0 });
    this.props.onHeightChange();
    if (this.props.onClose) this.props.onClose();
    // clear after click away
    if (this.selector) this.selector.removePhoto();
  }

  tagClick(tag) {
    const { selectedTags } = this.state;
    const tagIds = selectedTags.map(tag => tag._id);
    const tagIndex = tagIds.indexOf(tag._id);
    if (tagIndex > -1) {
      selectedTags.splice(tagIndex, 1);
      this.setState({ selectedTags: [ ...selectedTags ] });
    } else {
      this.setState({ selectedTags: [ ...selectedTags, tag ] });
    }
  }

  setSelectedUsers(users) {
    this.setState({ selectedUsers: users });
  }

  openShoutout() {
    if (!this.state.isEditing) {
      this.setState({ isEditing: true });
      this.props.onHeightChange();
      this.dropdownComponent.userDropdown.downshift.dropdownInput.focus();
    }
  }

  // onfocus and onblur set the state for the s key ability to call the shoutout box.
  onFocus(){
    this.props.setTextFieldFocus(true);
  }

  onBlur(){
    this.props.setTextFieldFocus(false);
  }

  onFileBeginProcess() {
    let maxWidth = Math.min(document.getElementById('send-wrapper').clientWidth, 480);
    let loadingImageEl = <div style={{ width: maxWidth }} className="placeholder uploading">Uploading Image...</div>;
    this.setState({ photoElement: loadingImageEl, photoLoading: true });
  }

  onFileProcess(event) {
    if (event === null) {
      this.setState({ photoElement: null, photoLoading: false });
      return;
    }
    const image = new Image();
    image.onload = () => {
      let widthRatio = image.width / this.maxWidth;
      let heightRatio = image.height / this.maxHeight;
      let height, width;
      this.maxWidth = Math.min(document.getElementById('send-wrapper').clientWidth, window.innerWidth > 480 ? 430 : 215 );
      this.maxHeight = 226 * (this.maxWidth / 430);
      if (widthRatio > heightRatio) {
        height = image.height * (this.maxWidth / image.width);
        width = this.maxWidth;
        this.imageClasses = ' wide-image';
        if (image.width < this.maxWidth) {
          this.imageClasses = ' small-width';
        }
      } else {
        this.imageClasses = ' tall-image';
        height = this.maxHeight;
        width = image.width * (this.maxHeight / image.height);
        if (image.height < this.maxHeight) {
          this.imageClasses = ' small-height';
        }
      }
      this.sizeSet = true;
      let margin = width > (this.maxWidth - 20) ? ' left-align' : ' centered';
      let imageStyle = 'show-image' + this.imageClasses;
      let photo = <div style={{ height, width, margin }} className={'placeholder' + margin}>
        <img src={event.target.result} style={{ height, width }} className={imageStyle} ref={(ref) => this.imagePreview = ref} alt="preview"/>
        <div style={{ height, width, position: 'absolute' }} className="dark-overlay">
          <Icon onClick={() => this.selector.removePhoto()}>delete</Icon>
        </div>
      </div>;
      this.setState({ photoElement: photo, photoLoading: false });
    };
    image.src = event.target.result;
  }

  renderPhoto() {
    return this.state.photoElement;
  }

  render() {
    const { currentUser, users, teams, tags, modalMode } = this.props;
    const { isEditing, isSending, characterCount, message, selectedTags, selectedUsers, photoLoading } = this.state;
    const photoURL = currentUser ? currentUser.picture : '';

    let editingClassname = 'editing-wrapper';
    let transformClassName = 'send-shoutout-text-wrapper';
    let backgroundClassName = 'send-shoutout-background';
    let parentClassName = 'send-shoutout-parent';
    let textFieldSectionClass = 'text-field-section-animated';
    let overlayClass = 'drag-overlay';
    let bottomButtonsSection = 'bottom-buttons-section';

    if (modalMode) parentClassName += ' modal';
    if (isEditing) {
      editingClassname += ' editing';
      transformClassName += ' editing';
      backgroundClassName += ' editing';
    }

    if (this.state.dragCounter === 0 || this.state.dropComplete || window.innerWidth < 480) overlayClass += ' none';

    return (
      <div className={parentClassName}>
        <div className={backgroundClassName} onClick={this.backgroundClick.bind(this)}></div>
        <Paper
          className="send-shoutout-wrapper"
          id={'send-wrapper'}
          style={{ cursor: (isEditing ? 'default' : 'pointer') }}
          onClick={() => {
            if (!this.state.isEditing) {
              if (window.innerWidth > 480) {
                this.setState({ isEditing: true });
                this.props.onHeightChange();
                this.dropdownComponent.userDropdown.dropdownInput.current.focus();
              } else {
                this.props.setShowSendShoutoutModal(true);
              }
            }
          }}
        >
          <img src={photoURL} className="floating-avatar" alt="sender" />

          <div className={editingClassname}>
            <div
              className="to-wrapper"
              onFocus={this.onFocus.bind(this)}
              onBlur={this.onBlur.bind(this)}
            >
              <div className="chips-to" >TO:</div>
              <UsersSelector
                ref={(ref) => this.dropdownComponent = ref}
                users={users}
                teams={teams}
                selectedUsers={selectedUsers}
                setSelectedUsers={this.setSelectedUsers.bind(this)}
              />
            </div>

            <div className="text-field-section">
              <div className={textFieldSectionClass}>
                <textarea
                  ref={(ref) => this.sendShoutoutTextarea = ref}
                  value={message}
                  onFocus={this.onFocus.bind(this)}
                  onBlur={this.onBlur.bind(this)}
                  onChange={this.shoutoutMessageChanged.bind(this)}
                  className="send-shoutout-textarea"
                />
                <div className="character-count" style={{ color: (characterCount > 250 ? '#d0021b' : '#6a6a66') }}>{characterCount}/250</div>
              </div>


              <div className={transformClassName}>
                <div className="send-shoutout-text1">WHO WOULD YOU LIKE TO SHOUT OUT?</div>
                <div className="send-shoutout-text2">{message.length ? '' : 'What would you like to say?'}</div>
              </div>
            </div>

            {this.renderPhoto()}

            <div className="error-text">{this.state.imageError}</div>

            <div className={bottomButtonsSection}>
              { (window.innerWidth > 480 || modalMode) &&
                <PhotoSelector
                  ref={(ref) => this.selector = ref}
                  token={this.props.token}
                  onError={(imageError) => this.setState({ imageError })}
                  onFileBeginProcess={() => this.onFileBeginProcess()}
                  onFileProcess={(event) => this.onFileProcess(event)}
                />
              }
              <TagSelector tags={tags} selectedTags={selectedTags} onSelectedTag={this.tagClick.bind(this)} />
              <PrismButton
                onClick={this.sendShoutout.bind(this)}
                disabled={!this.isShoutoutValid || isSending || photoLoading}
                style={{ width: 200 }}
              >
                {isSending ? "Sending..." : "Send Shoutout"}
              </PrismButton>
            </div>
          </div>
          <div ref={(ref) => this.dragOverlayRef = ref} className={overlayClass}>
            {this.state.dragText} Photo Here
          </div>
        </Paper>

      </div>
    );
  }
}

const mapStateToProps = ({ hotkeyStore, usersStore, tagsStore, authStore: { headers } }) => {
  const { users, currentUser, usersLoading } = usersStore;
  const { tags, tagsLoading } = tagsStore;
  const { isFocus, showSend } = hotkeyStore;
  const availableUsers = users.filter(user => user.uid !== currentUser.uid && !user.deactivated);

  return { currentUser, users: availableUsers, isFocus, showSend, usersLoading, teams: [], teamsLoading: false, tags, tagsLoading, token: headers.idtoken };

};

export default connect(mapStateToProps, { createShoutout, setTextFieldFocus, setShowSendShoutoutModal })(SendShoutout);



// WEBPACK FOOTER //
// ./src/components/SendShoutout.js